<app-card-widget title="Text Messages" *ngIf="invoice$ | async">

  <form [formGroup]="form" id="sms-form" (ngSubmit)="save()" *ngIf="usersMap$ | async as usersMap" novalidate>

    <div class="card-section-container">

      <div class="card-section">

        <mat-nav-list>
          <mat-list-item *ngFor="let item of textMessages$ | async" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>sms</mat-icon>
            <h3 matLine>{{item.content}}</h3>
            <span matLine>{{item.recipient}}</span>
            <div class="list-item-container">
              <div class="status-label" [ngClass]="getStatusClass(item.status)">{{item.status}}</div>
              <div class="list-item-timestamp">{{item.created_at | date:'short'}}</div>
            </div>
          </mat-list-item>
        </mat-nav-list>

      </div>

      <div class="card-section" *ngIf="selectedItem || added">

        <app-text label="State" *ngIf="!added">{{ selectedItem.status }}</app-text>

        <mat-form-field *ngIf="added">
          <mat-select placeholder="Template" formControlName="smsTemplateId" (selectionChange)="templateChange($event)">
            <mat-option *ngFor="let template of smsTemplates$ | async" [value]="template">
              {{template.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Recipient" *ngIf="!added">{{selectedItem.recipient}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput placeholder="Recipient" formControlName="recipient" (blur)="formatPhoneNumberOnBlur()"/>
        </mat-form-field>

        <app-text label="Message" *ngIf="!added">{{selectedItem.content}}</app-text>

        <mat-form-field *ngIf="added">
          <textarea matInput placeholder="Message" formControlName="message" rows="6"></textarea>
        </mat-form-field>

        <app-text label="User" *ngIf="!added">{{usersMap.get(selectedItem.created_by)?.name}}</app-text>

        <app-text label="Created" *ngIf="!added">{{selectedItem.created_at | date:'medium'}}</app-text>

        <div *ngIf="!added && selectedItem.events?.length > 0" class="events-section">
          <p class="mat-body-2 events-header">Events</p>
          <div *ngFor="let event of getSortedEvents(selectedItem.events)" class="event-row mat-body-1">
            <span>{{ event.event_at | date:'medium' }}</span>
            <span>{{ event.status_type }}</span>
          </div>
        </div>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving" form="sms-form">Send</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


